import { render } from "./OverlayHeader.vue?vue&type=template&id=6dba2966&scoped=true"
import script from "./OverlayHeader.vue?vue&type=script&lang=js"
export * from "./OverlayHeader.vue?vue&type=script&lang=js"

import "./OverlayHeader.vue?vue&type=style&index=0&id=6dba2966&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dba2966"]])

export default __exports__